import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';
import textSVG from '../../assets/404 text.svg';
import illustrationSVG from '../../assets/404-error.svg';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/'); // Go to home page
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-image-container">
          <p className="error-message">
          404 page not found
        </p>  
          <img 
            src={textSVG} 
            alt="404 Text"
            className="error-text"
          />
          <img 
            src={illustrationSVG} 
            alt="404 Illustration" 
            className="error-image"
          />
        </div>
        <p className="error-message">
          Sorry the page does not exist or have been deleted.
        </p>
        <button
          onClick={handleGoHome}
          className="home-button"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;